module.exports = __webpack_public_path__ + "static/img/2.9000b35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/2.png
// module id = Izz9
// module chunks = 0